//@ts-check
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Center from './Center';

var Loader = function Loader(_ref) {
  var children = _ref.children;
  return React.createElement(Center, null, React.createElement(Grid, {
    container: true,
    direction: "column",
    alignItems: "center"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(CircularProgress, {
    color: "primary"
  })), React.createElement(Grid, {
    item: true
  }, React.createElement(Typography, {
    variant: "inherit"
  }, children))));
};

Loader.defaultProps = {
  children: null
};
export default Loader;